import { ModeForm } from "constants/enum";
import { CREATE_SUCCESS_MESSAGE } from "constants/index";

import { useCreateOneBaseRequestControllerRequestEntity } from "generated";
import { useNotification } from "hooks/useNotification";
import { useNavigate } from "react-router-dom";

import { RequestForm } from "./RequestForm";

export const RequestCreateComponent = () => {
  const navigate = useNavigate();
  const {
    mutate,
    isSuccess,
    error: createError,
  } = useCreateOneBaseRequestControllerRequestEntity();

  const handleSubmit = (dataSubmit: any) => {
    mutate(
      {
        data: {
          request: {
            name: dataSubmit?.request?.name,
            status: dataSubmit?.request?.status,
            clientId: dataSubmit?.request?.clientId?.value,
            contractor: dataSubmit?.request?.contractor,
            dueDate: dataSubmit?.request?.dueDate,
            requestor: dataSubmit?.request?.requestor,
            picId: dataSubmit?.request?.picId?.value,
            description: dataSubmit?.request?.description,
          },
          ...(dataSubmit?.assigneeIds && dataSubmit?.assigneeIds?.length > 0
            ? {
                assigneeIds: (dataSubmit?.assigneeIds as string[])?.map(
                  (e: any) => e?.value as string
                ),
              }
            : {}),
        },
      },
      {
        onSuccess(data) {
          navigate(`/request/edit/${data.data.id as string}`);
        },
      }
    );
  };
  useNotification(createError, isSuccess, CREATE_SUCCESS_MESSAGE);
  return (
    <RequestForm
      title="General information"
      handleSubmitForm={handleSubmit}
      mode={ModeForm.Create}
    />
  );
};
